import { ChildConnectionFormVM } from '../child-connection-form.viewmodel';
import { ConnectionType, IChildConnectionDTO, IConnectionDetailsDTO } from '../../../../../../api/connections.dao';
import { configList, UJLFieldKey } from './unique-joining-link-child-connection.config';

export class UniqueJoiningLinkChildConnectionVM extends ChildConnectionFormVM {
    constructor(
        accountId: number,
        eventId: number,
        childConnection: IChildConnectionDTO,
        parentConnectionDetails: IConnectionDetailsDTO,
        onChildConnectionUpdated: (childConnection: IChildConnectionDTO, parentConnectionId: number) => void
    ) {
        super(accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated);
        this.initFormDataCtrl(configList, this.composeInitialData(childConnection));
    }

    public get type(): ConnectionType { return ConnectionType.UniqueJoiningLink; }

    public async updateChildConnection(): Promise<boolean> {
        return super.updateChildConnection(this.composeUpdateChildConnectionDetails());
    }

    private composeUpdateChildConnectionDetails(): Partial<IChildConnectionDTO> {
        return {
            type: this.type,
            connectionLink: this.formDataCtrl.getValue(UJLFieldKey.CONNECTION_LINK) as string,
            joinMethodId: this.childConnection.joinMethodId,
            parentJoinMethodId: this.parentConnectionDetails.joinMethodId
        };
    }

    private composeInitialData(child: IChildConnectionDTO): Partial<IChildConnectionDTO> {
        const initialData = { ...child };
        initialData[UJLFieldKey.MEETING_INVITATION] = child[UJLFieldKey.MEETING_INVITATION] || '';

        return initialData;
    }

}